import styled from 'styled-components';

export const SReuseProductPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: ${({ theme }) => theme.color.white};

  .ant-collapse-header {
    align-items: center;
    background-color: ${({ theme }) => theme.color.grey95};
    font-weight: bold;
  }
`;

export const SBackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.color.brand_black};
  margin-bottom: 16px;
`;

export const SImagePlaceholder = styled.div`
  display: flex;
  width: 100%;
  height: 400px;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.color.grey_04};
  border-radius: 8px;
`;

export const SInfoRow = styled.div`
  display: flex;
  gap: 6px;
  padding: 8px 0;
`;

export const SReferenceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const SDeliveryRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const SAccordionContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 40px;
`;
